<template>
    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">申请描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{applyDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">审核操作</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="auditState">
                        <el-radio-group v-model="ruleForm.auditState" @change="setAuditState">
                            <el-radio label="1">同意</el-radio>
                            <el-radio label="-1">拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <!--14636 资产清理审核时，去掉自动清除的操作；-->
            <div class="form-group center" v-if="ruleForm.auditState == 1 && false">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="auditState">
                        <el-checkbox v-model="ruleForm.autoClearFlag">自动清除</el-checkbox>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" v-model="ruleForm.auditDesc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-asset-fiscal-clear-voucher-audit',
        desc: '清理单审核',
        props: ['applyDesc'],
        data: function () {
            return {
                ruleForm: {
                    auditState: '1',
                    autoClearFlag: true,
                },
            }
        },
        created: function () {
        },
        methods: {
            setAuditState: function () {
                let ruleForm = this.ruleForm;
                if(Utils.isFalse(ruleForm.auditState)) {
                    ruleForm.autoClearFlag = false;
                } else {
                    ruleForm.autoClearFlag = true;
                }
                this.ruleForm = Utils.merge({}, ruleForm);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                let ruleForm = self.ruleForm;
                if(ruleForm.auditState == 1) {
                    ruleForm.autoClearFlag = false;
                }
                result.data = ruleForm;
                return result;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetFiscalClearVoucherAudit.vue